"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGuestText = void 0;

var getGuestText = function getGuestText(roomOccupancy, translation, label) {
  var count = roomOccupancy.reduce(function (sum, room) {
    return sum + room[label];
  }, 0);

  if (count === 0) {
    return null;
  }

  var translationKey = "".concat(label, "Label");
  return "".concat(count, " ").concat(translation.result[translationKey]);
};

exports.getGuestText = getGuestText;